import React from 'react';
import { motion } from 'framer-motion';
import { FaStar, FaUsers, FaLightbulb, FaCheckCircle } from 'react-icons/fa';

const values = [
  {
    icon: <FaStar />,
    title: 'Excellence',
    description: 'Nous visons l\'excellence dans chaque prestation que nous proposons.'
  },
  {
    icon: <FaUsers />,
    title: 'Proximité',
    description: 'Une relation de confiance et de proximité avec chacun de nos clients.'
  },
  {
    icon: <FaLightbulb />,
    title: 'Innovation',
    description: 'Des solutions innovantes pour répondre aux défis de demain.'
  },
  {
    icon: <FaCheckCircle />,
    title: 'Fiabilité',
    description: 'Un engagement de fiabilité et de transparence dans toutes nos actions.'
  }
];

const Values = () => {
  return (
    <section className="values">
      <div className="container">
        <motion.div 
          className="section-header"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2>Nos Valeurs</h2>
          <p>Les principes qui guident notre action au quotidien</p>
        </motion.div>
        <div className="values-grid">
          {values.map((value, index) => (
            <motion.div
              key={index}
              className="value-card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              whileHover={{ y: -5 }}
            >
              {value.icon}
              <h3>{value.title}</h3>
              <p>{value.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Values;
